import React from "react";
import PropTypes from "prop-types";
import { WrappedItem, RTEWrapper } from "BaseComponents/Wrappers";
import { H3 } from "BaseComponents/Text";
import styled from "styled-components";
import media from "styled-media-query";
import { Image } from "BaseComponents/Image";
import { PrimaryButton, ButtonText } from "Buttons";
import { getResponsiveImage } from "Helpers/ImageHelper";
import { useGlobal } from "reactn";

export const InfoItem = ({ Heading, Image: InnerImage, Text, Link }) => {
  const [theme] = useGlobal("theme");

  
  return (
    <WrappedItem
      justifyContent="space-between"
      alignItems="center"
      background="white"
      margin="15px"
      padding="30px 20px"
      border={`1px solid ${theme.colors.grey}`}
      smallPadding="20px"
      className={"wrappedItem"}
    >
      <TopWrapper>
        <Image
          size="200px"
          smallSize="160px"
          borderRadius="50%"
          bgImage={InnerImage}
        />
        <H3 margin="30px 0 0 0" textAlign="center">
          {Heading}
        </H3>
        <RTEWrapper
          textAlign="center"
          margin="10px 0 0 0"
          color="black"
          dangerouslySetInnerHTML={{ __html: Text }}
        />
      </TopWrapper>
      {Link && (
        <PrimaryButton
          smallmargin="5px 0 0 0"
          widthsmall="auto"
          minwidthsmall="220px"
          href={Link.Url}
          ariaLabel={Heading}
        >
          <ButtonText paddingsmall="0 2rem" heading={Heading}>
            {Link.Name}
          </ButtonText>
        </PrimaryButton>
      )}
    </WrappedItem>
  );
};

const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
